module.exports = __webpack_public_path__ + "img/右侧成绩 @2x.31da424e.png";